import _ from 'lodash';


function generateId(prefix) {
    return _.uniqueId(prefix);
}

export default {generateId};

